/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import './style/dialog.scss';

import React from 'react';
import classNames from 'classnames';
import ButtonController from "../button/buttonController";
import {ControlContext} from "../util/controlContext";
import {generateUUID, hasHover} from "../util/controlUtil";
import {colorIsWhite, convertColor} from "../util/colorUtil";
import {DialogActionShape} from "./dialogController";

interface DialogProps {
    onClose: Function,
    message: string,
    open: boolean,
    title?: string,
    actions?: DialogActionShape[] | DialogActionShape | null,
    transparent?: boolean,
    persistent?: boolean,
    content?: React.ReactElement | null,
    containerClass: string,
}

export default class InlineDialog extends React.Component<DialogProps> {
    declare context: React.ContextType<typeof ControlContext>;
    static contextType = ControlContext;

    static defaultProps = {
        title: 'Bericht van Klaverjassen',
        actions: null,
        transparent: false,
        persistent: true,
        content: null,
        containerClass: '',
    };

    constructor(props: any) {
        super(props);
    }

    dialog: HTMLElement | null = null;
    id = generateUUID();

    onClickBackground = () => {
        const {persistent, onClose} = this.props;
        if (!persistent && this.dialog !== null && !hasHover(this.dialog))
            onClose();
    };

    onClickAction = (onClick: Function | undefined) => (evt: React.MouseEvent) => {
        if (onClick !== undefined) onClick(evt);
        this.props.onClose();
    };

    onClickDefault = () => {
        this.props.onClose();
    }

    getColorStyle = (): object => {
        // noinspection JSDeprecatedSymbols
        const {baseColor, contrastColor} = this.context,
            color = colorIsWhite(contrastColor) ? baseColor : contrastColor;
        return {color: convertColor(color)};
    };

    getActions = () => {
        const {actions} = this.props;
        if (actions === undefined || actions === null) return this.generateDefaultAction();
        if (Array.isArray(actions))
            return actions.map((action: DialogActionShape, key: any) => (
                <ButtonController key={key} label={action.label} onClick={this.onClickAction(action.onClick)}
                                  type='outlined' containerClass='dialogButton'/>
            ));
        return <ButtonController label={actions.label} onClick={this.onClickAction(actions.onClick)} type='outlined'/>
    };

    generateDefaultAction = (): React.ReactNode => <ButtonController label={'Oke'} onClick={this.onClickDefault}
                                                                     type='outlined' containerClass='dialogButton'/>;

    renderTitle = (): React.ReactNode => {
        const {title} = this.props;
        return (
            <div className='dialogTitleContainer'>
                <label className='dialogTitle' style={this.getColorStyle()}>{title}</label>
            </div>
        )
    };

    renderMessage = (): React.ReactNode => {
        const {message, content} = this.props;
        return (
            <div className='dialogMessageContainer'>
                <p className='dialogMessage'>{message}</p>
                {content !== undefined && content}
            </div>
        )
    };

    renderActions = (): React.ReactNode => {
        const actions = this.getActions();
        return (
            <div className='dialogActionsContainer'>
                {actions}
            </div>
        )
    };

    render = () => {
        const {open, transparent, containerClass} = this.props;
        if (!open) return null;
        return (
            <div className={classNames('dialogContainer', transparent && 'transparent', containerClass)}
                 onClick={this.onClickBackground}>
                <div className='dialog' ref={ref => {
                    this.dialog = ref
                }}>
                    {this.renderTitle()}
                    {this.renderMessage()}
                    {this.renderActions()}
                </div>
            </div>
        )
    }
}